"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ANALYTICAL_ENVIRONMENT = exports.DASHBOARDS_ENVIRONMENT = exports.PROPERTY_CONTROLS_DUAL_AXIS = exports.PROPERTY_CONTROLS_SECONDARY_CHART_TYPE = exports.PROPERTY_CONTROLS_PRIMARY_CHART_TYPE = exports.PROPERTY_CONTROLS = void 0;
// (C) 2019-2021 GoodData Corporation
exports.PROPERTY_CONTROLS = "properties.controls";
exports.PROPERTY_CONTROLS_PRIMARY_CHART_TYPE = "properties.controls.primaryChartType";
exports.PROPERTY_CONTROLS_SECONDARY_CHART_TYPE = "properties.controls.secondaryChartType";
exports.PROPERTY_CONTROLS_DUAL_AXIS = "properties.controls.dualAxis";
exports.DASHBOARDS_ENVIRONMENT = "dashboards";
exports.ANALYTICAL_ENVIRONMENT = "analyticalDesigner";
//# sourceMappingURL=properties.js.map